// eslint-disable-next-line no-unused-vars
export default {
  methods: {
    formatAsMoney(field) {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      });
      return formatter.format(field);
    },
  },
};
